<template>
  <div class="wrap">
    <van-sticky>
      <van-nav-bar
        class="defaultNav"
        :title="detailsInfo.projectName"
        left-text
        left-arrow
        ref="mtHeader"
        @click-left="back()"
      />
    </van-sticky>
    <van-dropdown-menu :active-color="activeColor" class="dropdown-box">
      <van-dropdown-item
        v-model="UnitType"
        :options="UnitTypeData"
        @change="hideChange"
      />
      <div class="count">Total:{{ Total }}</div>
    </van-dropdown-menu>
    <div class="plans-box">
      <el-image
        v-for="(item, index) in unitData"
        :key="index"
        :src="imgUrl + item.img"
        @click="previewImgEmit(index)"
        :class="{ 'margin-top': index >= 2, 'margin-top-ipad': index >= 1 }"
      >
        <div slot="error">
          Load Fail
        </div>
      </el-image>
    </div>
  </div>
</template>

<script>
export default {
  name: "FloorPlan",
  data() {
    return {
      UnitType: 0,
      UnitTypeData: [],
      Total: 0,
      unitData: [],
      unitDataList: [],
      activeColor: "#00D2C8",
      img_suffix: "",
      defaultImgResize:
        "?x-oss-process=image/auto-orient,1/interlace,1/resize,p_70/quality,q_100"
    };
  },
  props: {
    detailsInfo: {},
    RouteInfo: {},
    imgUrl: "",
    brokeName: "ECOPROP"
  },
  mounted() {
    console.log(this.RouteInfo);
    this.querySysConfig();
    this.queryUnitType();
    if (this.brokeName === "ECOPROP") {
      activeColor = "#00D2C8";
    } else if (this.brokeName === "Huttons") {
      activeColor = "#041E42";
    }
  },
  methods: {
    querySysConfig() {
      this.$Post(this.$api.querySysConfig, {}).then(res => {
        if (res.code == 0) {
          this.hostUrl = res.datas.img_url;
          sessionStorage.setItem("hostUrl", res.datas.img_url);
          this.img_suffix = res.datas.oss_img_resize;
        }
      });
    },
    back() {
      this.$emit("hideDetail", "showFloor");
    },
    queryUnitType() {
      let data = {
        projectId: this.RouteInfo.projectId,
        pageNo: 1,
        pageSize: 9999
      };
      this.$Post(this.$api.queryUnitType, data).then(res => {
        if (res.code == 0) {
          if (res.datas.length) {
            this.UnitTypeData = res.datas.map(i => {
              return {
                text: i,
                value: i
              };
            });
            this.UnitTypeData.unshift({
              text: "All Plans",
              value: ""
            });
            this.UnitType = this.UnitTypeData[0].value;
            this.menuFn(this.UnitType);
          }
        }
      });
    },
    menuFn(val) {
      let data = {
        type: val,
        projectId: this.RouteInfo.projectId,
        pageNo: 1,
        pageSize: 9999
      };
      if (val === "All Plans") {
        data.type = "";
      }
      this.$Post(this.$api.queryFloorPlansByType, data, true).then(res => {
        if (res.code == 0) {
          this.Total = res.datas.count;
          this.unitData = res.datas.lists;
          let unitDataList = [];
          res.datas.lists.forEach(ele => {
            unitDataList.push(this.imgUrl + ele.img);
          });
          this.unitDataList = unitDataList;
        }
      });
    },
    hideChange(val) {
      this.menuFn(val);
    },
    previewImgEmit(index) {
      this.$emit("previewImg", this.unitData, index);
    }
  }
};
</script>

<style lang="less" scoped>
.wrap {
  .dropdown-box {
    .count {
      flex: 1;
      text-align: center;
      color: #6c7b8a;
      font-size: 12px;
      line-height: 50px;
    }
  }
  .plans-box {
    padding: 0.2rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .el-image {
      width: 1.62rem;
      height: 1.3rem;
      border-radius: 15px;
      .el-error {
        width: 100%;
        height: 100%;
        display: flex;
        vertical-align: middle;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #c0c4cc;
        background: #f5f7fa;
      }
    }
    .margin-top {
      margin-top: 0.1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/shareMobile/floorPlan.vue